import { graphql } from '@/gql';
import type { ChargeUserForGroceriesWithPartnerSubsidyIfAvailableMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const chargeUserForGroceriesWithPartnerSubsidyIfAvailable = async ({
  orderId,
  amount,
  notes,
}: ChargeUserForGroceriesWithPartnerSubsidyIfAvailableMutationVariables): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation ChargeUserForGroceriesWithPartnerSubsidyIfAvailable($orderId: String!, $amount: Float!, $notes: String!) {
        chargeUserForGroceriesWithPartnerSubsidyIfAvailable(orderId: $orderId, amount: $amount, notes: $notes) {
          id
        }
      }
    `),
    variables: {
      orderId,
      amount,
      notes,
    },
  });

  return !!response.data?.chargeUserForGroceriesWithPartnerSubsidyIfAvailable;
};
